import React, { useEffect, useState } from 'react';
import { ReactComponent as WarningRed } from 'assets/icons/pencil.svg';
import { Modal } from 'components';
import { Input } from 'antd';
import { Select } from 'components';
import { createUser, getGroupById, getGroups, getPrivilegesByGroup } from 'store/adminPanel/actions';
import { useDispatch } from 'react-redux';

const CreateModal = ({ isVisible, setVisible, users }) => {

    const dispatch = useDispatch();
    const [userID, setUserID] = useState("");
    const [userEmail, setUserEmail] = useState("");
    const [userPassword, setUserPassword] = useState("");
    const [userFirstName, setUserFirstName] = useState("");
    const [userLastName, setUserLastName] = useState("");
    const [userGroup, setUserGroup] = useState([]);
    const [privileges, setPrivileges] = useState([]);
    const [error, setError] = useState(true);
    const [errorId, setErrorId] = useState(false);
    const [errorEmail, setErrorEmail] = useState(false);
    const [errorPassword, setErrorPassword] = useState(true);
    const [groups, setGroups] = useState([]);

    useEffect(()=>{
        getGroups().then(groups => {
            setGroups(groups.map(item=>item.name));
            }).catch(error => {
            console.error("Error fetching groups:", error);
            });
    },[]);

    useEffect(()=>{
        if(!errorPassword && userID && userEmail && userPassword && userFirstName && userLastName && userGroup && !users.map(user=>user.id).includes(userID) && !users.map(user=>user.email).includes(userEmail)){
            setError(false);
            setErrorId(false);
            setErrorEmail(false);
        } else if (!userID || !userEmail || !userPassword || !userFirstName || !userLastName || !userGroup){
            setError(true);
            setErrorId(false);
            setErrorEmail(false);
        } else if (users.map(user=>user.id).includes(userID) || users.map(user=>user.email).includes(userEmail)){
            if(users.map(user=>user.id).includes(userID) && users.map(user=>user.email).includes(userEmail)){
                setError(false);
                setErrorId(true);
                setErrorEmail(true);
            } else if (users.map(user=>user.id).includes(userID)){
                setError(false);
                setErrorId(true);
                setErrorEmail(false);
            } else {
                setError(false);
                setErrorId(false);
                setErrorEmail(true);
            }
            
        }
    },[userID, userEmail, userPassword, userFirstName, userLastName, userGroup]);

    const handleClose = () => {
        setVisible(false);
        setUserID("");
        setUserEmail("");
        setUserPassword("");
        setUserFirstName("");
        setUserLastName("");
        setUserGroup([]);
    }

    const handleOk = () => {
        const fullName = userFirstName + " " + userLastName;
        dispatch(createUser(userPassword, userID, userFirstName, userLastName, fullName, userEmail, userGroup, privileges));
        setVisible(false);
        setUserID("");
        setUserEmail("");
        setUserPassword("");
        setUserFirstName("");
        setUserLastName("");
        setUserGroup([]);
    }

    const handlePasswordChange = (value) => {
        setUserPassword(value);

        const hasUpperCase = /[A-Z]/.test(value);
        const hasLowerCase = /[a-z]/.test(value);
        const hasNumbers = /[0-9]/.test(value);
        const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

        if (hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar && value.length>=8) {
            setErrorPassword(false);
        } else {
            setErrorPassword(true);
        }
    }

    return (
      <Modal
        isVisible={isVisible}
        Icon={WarningRed}
        onCancel={() => handleClose()}
        onOk={() => handleOk()}
        okButtonProps={{disabled:error || errorId || errorEmail}}
        title={<h1 style={{color:"#4F2D7F", marginTop:"0.563rem", marginLeft:"1.875rem"}}>Create User</h1>}
        width={817}
        okText="Create User"
        className={'modal-admin-create-user'}
      >
        <div>
            {error && <span style={{color:"#f76b8a"}}>Παρακαλώ συμπληρώστε όλα τα πεδία</span>}
        </div>
        <div>
            {errorId && <span style={{color:"#f76b8a"}}>Το User ID υπάρχει ήδη</span>}
        </div>
        <div>
            {errorEmail && <span style={{color:"#f76b8a"}}>Το Email υπάρχει ήδη</span>}
        </div>
        
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>User ID</span>
            <Input style={{height:"40px"}} value={userID} onChange={event=>setUserID(event.target.value)}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Email</span>
            <Input style={{height:"40px"}} value={userEmail} onChange={event=>setUserEmail(event.target.value)}></Input>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Password</span>
            <Input type="password" style={{height:"40px"}} value={userPassword} onChange={event=>handlePasswordChange(event.target.value)}></Input>
        </div>
        <div>
            {errorPassword && <span style={{color:"#f76b8a", position:"absolute"}}>Το Password πρέπει να είναι τουλάχιτον 8 χαρακτήρες και να περίεχει τουλάχιστον ένα κεφαλαίο, έναν αριθμό και έναν ειδικό χαρακτήρα</span>}
        </div>
        <div style={{marginTop:"55px", display:"flex"}}>
            <div>
                <span className='input-titles'>First Name</span>
                <Input style={{width:"350px",height:"40px"}} value={userFirstName} onChange={event=>setUserFirstName(event.target.value)}></Input>
            </div>
            <div style={{marginLeft:"65px"}}>
                <span className='input-titles'>Last Name</span>
                <Input style={{width:"350px",height:"40px"}} value={userLastName} onChange={event=>setUserLastName(event.target.value)}></Input>
            </div>
        </div>
        <div style={{marginTop:"20px"}}>
            <span className='input-titles'>Group</span>
            <Select
                showSearch={false}
                size="small"
                mode="multiple"
                value={userGroup}
                placeholder="Select a group"
                defaultValue={['BaseResourceGroup']}
                onChange={value=>setUserGroup(value)}
                options={groups.map(item => ({
                    label: item,
                    value: item
                  }))}
            />
        </div>
      </Modal>
    );
  };
  export default CreateModal;